module.exports = __webpack_public_path__ + "img/material.56530569.jpg";